export const TasksStacklets = {
  CREATE: {
    name: 'create',
    description: {
      progress: 'Stacklet is creating.',
      completed: 'Stacklet was created.',
    },
  },
  REBUILD: {
    name: 'rebuild',
    description: {
      progress: 'Stacklet is rebuilding.',
      completed: 'Stacklet was rebuilt.',
    },
  },
  POWER_ON: {
    name: 'power_on',
    description: {
      progress: 'Stacklet is powering on.',
      completed: 'Stacklet was power on.',
    },
  },
  POWER_OFF: {
    name: 'power_off',
    description: {
      progress: 'Stacklet is powering off.',
      completed: 'Stacklet was power off.',
    },
  },
  POWER_CYCLE: {
    name: 'power_cycle',
    description: {
      progress: 'Stacklet is rebooting.',
      completed: 'Stacklet was rebooted.',
    },
  },
  ENABLE_RECOVERY_MODE: {
    name: 'enable_recovery_mode',
    description: {
      progress: 'Stacklet is changing boot device.',
      completed: 'Stacklet was changed boot device.',
    },
  },
  DISABLE_RECOVERY_MODE: {
    name: 'disable_recovery_mode',
    description: {
      progress: 'Stacklet is changing boot device.',
      completed: 'Stacklet was changed boot device.',
    },
  },
  RENAME: {
    name: 'rename',
    description: {
      progress: 'Stacklet is renaming.',
      completed: 'Stacklet was renamed.',
    },
  },
  RESIZE: {
    name: 'resize',
    description: {
      progress: 'Stacklet is resizing.',
      completed: 'Stacklet was resized.',
    },
  },
  RESTORE: {
    name: 'restore',
    description: {
      progress: 'Stacklet is restoring.',
      completed: 'Stacklet was restored.',
    },
  },
  RESET_PASSWORD: {
    name: 'reset_password',
    description: {
      progress: 'Root Password is resetting.',
      completed: 'Root Password was reset.',
    },
  },
  DESTROY: {
    name: 'destroy',
    description: {
      progress: '',
      completed: 'Stacklet was deleted.',
    },
  },
  ENABLE_PRIVATE_NETWORKING: {
    name: 'enable_private_networking',
    description: {
      progress: 'Enabling private networking.',
      completed: 'Private networking was enabled.',
    },
  },
  SNAPSHOT: {
    name: 'snapshot',
    description: {
      progress: 'Snapshot is creating.',
      completed: 'Snapshot was created.',
    },
  },
  VOLUME_ATTACH: {
    name: 'volume_attach',
    description: {
      progress: 'Attaching block storage device.',
      completed: 'Block storage was attached.',
    },
  },
  VOLUME_DETACH: {
    name: 'volume_detach',
    description: {
      progress: 'Detaching block storage device.',
      completed: 'Block storage was detached.',
    },
  },
  FIREWALL_ATTACH: {
    name: 'firewall_attach',
    description: {
      progress: 'Attaching firewall.',
      completed: 'Firewall was attached.',
    },
  },
  FIREWALL_DETACH: {
    name: 'firewall_detach',
    description: {
      progress: 'Detaching firewall.',
      completed: 'Firewall was detached.',
    },
  },
  ENABLE_BACKUPS: {
    name: 'enable_backups',
    description: {
      progress: 'Enabling backup.',
      completed: 'Backups was enabled.',
    },
  },
  DISABLE_BACKUPS: {
    name: 'disable_backups',
    description: {
      progress: 'Disabling backup.',
      completed: 'Backups was disabled.',
    },
  },
};

export const TasksVolumes = {
  CREATE: {
    name: 'create',
    description: {
      progress: 'Volume is creating.',
      completed: 'Volume was created.',
    },
  },
  ATTACH: {
    name: 'attach',
    description: {
      progress: 'Volume is attaching.',
      completed: 'Volume was attached.',
    },
  },
  DETACH: {
    name: 'detach',
    description: {
      progress: 'Volume is detaching.',
      completed: 'Volume was detached.',
    },
  },
  DELETE: {
    name: 'delete',
    description: {
      progress: 'Volume is deleting.',
      completed: 'Volume was deleted.',
    },
  },
  RESIZE: {
    name: 'resize',
    description: {
      progress: 'Volume is resizing.',
      completed: 'Volume was resized.',
    },
  },
  RENAME: {
    name: 'rename',
    description: {
      progress: 'Volume is renaming.',
      completed: 'Volume was renamed.',
    },
  },
};

export const TasksImages = {
  CREATE: {
    name: 'create',
    description: {
      progress: 'Image is creating.',
      completed: 'Image was created.',
    },
  },
  TRANSFER: {
    name: 'transfer',
    description: {
      progress: 'Image is transferring.',
      completed: 'Image was transferred.',
    },
  },
  DELETE: {
    name: 'delete',
    description: {
      progress: 'Image is deleting.',
      completed: 'Image was deleted.',
    },
  },
  RESTORE: {
    name: 'restore',
    description: {
      progress: 'Image is restoring.',
      completed: 'Image was restored.',
    },
  },
  RENAME: {
    name: 'rename',
    description: {
      progress: 'Image is renaming.',
      completed: 'Image was renamed.',
    },
  },
  CONVERT: {
    name: 'convert',
    description: {
      progress: 'Image is converting.',
      completed: 'Image was converted.',
    },
  },
};

export const TasksFloatingIP = {
  ASSIGN: {
    name: 'assign',
    description: {
      progress: 'Assigning Floating IP.',
      completed: 'Floating IP was assigned.',
    },
  },
  UNASSIGN: {
    name: 'unassign',
    description: {
      progress: 'Unassigning Floating IP.',
      completed: 'Floating IP was unassigned.',
    },
  },
  DELETE: {
    name: 'delete',
    description: {
      progress: 'Deleting Floating IP.',
      completed: 'Floating IP was deleted.',
    },
  },
};

export const Loadbalancers = {
  CREATE: {
    name: 'create',
    description: {
      progress: 'Load balancer is creating.',
      completed: 'Load balancer was created.',
    },
  },
  ADD_RULE: {
    name: 'add_rule',
    description: {
      completed: 'Rule was added to load balancer.',
      progress: 'Rule is adding to load balancer.',
    },
  },
  REMOVE_RULE: {
    name: 'remove_rule',
    description: {
      completed: 'Rule was removed from load balancer.',
      progress: 'Rule is removing from load balancer.',
    },
  },
  ATTACH: {
    name: 'attach_stacklets',
    description: {
      progress: 'Attaching stacklets to load balancer.',
      completed: 'Attached stacklets to load balancer.',
    },
  },
  DETACH: {
    name: 'detach_stacklets',
    description: {
      progress: 'Detaching stacklets from load balancer.',
      completed: 'Detached stacklets from load balancer.',
    },
  },
  UPDATE: {
    name: 'update',
    description: {
      progress: 'Load balancer is updating settings.',
      completed: 'Load balancer updated settings.',
    },
  },
};

export const TasksDatabases = {
  CREATE: {
    name: 'create',
    description: {
      progress: 'Database is creating.',
      completed: 'Database was created.',
    },
  },
  POWER_ON: {
    name: 'power_on',
    description: {
      progress: 'Database is powering on.',
      completed: 'Database was powered on.',
    },
  },
  POWER_OFF: {
    name: 'power_off',
    description: {
      progress: 'Database is powering off.',
      completed: 'Database was powered off.',
    },
  },
  POWER_CYCLE: {
    name: 'power_cycle',
    description: {
      progress: 'Database is rebooting.',
      completed: 'Database was rebooted.',
    },
  },
  RESIZE: {
    name: 'resize',
    description: {
      progress: 'Database is resizing.',
      completed: 'Database resized.',
    },
  },
  RENAME: {
    name: 'rename',
    description: {
      progress: 'Database is renaming.',
      completed: 'Database renamed.',
    },
  },
  SNAPSHOT: {
    name: 'snapshot',
    description: {
      progress: 'Snapshot is creating.',
      completed: 'Snapshot was created.',
    },
  },
  SNAPSHOT_RENAME: {
    name: 'rename',
    description: {
      progress: 'Snapshot is renaming.',
      completed: 'Snapshot was renamed.',
    },
  },
  RESTORE: {
    name: 'restore',
    description: {
      progress: 'Database is restoring.',
      completed: 'Database was restored.',
    },
  },
  RESET_PASSWORD: {
    name: 'reset_password',
    description: {
      progress: 'DBAdmin password is resetting.',
      completed: 'DBAdmin password was reset.',
    },
  },
  DELETE: {
    name: 'delete',
    description: {
      progress: 'Database is deleting.',
      completed: 'Database was deleted.',
    },
  },
  ENABLE_BACKUPS: {
    name: 'enable_backups',
    description: {
      progress: 'Enabling backup.',
      completed: 'Backups enabled.',
    },
  },
  DISABLE_BACKUPS: {
    name: 'disable_backups',
    description: {
      progress: 'Disabling backup.',
      completed: 'Backups disabled.',
    },
  },
  FIREWALL_ATTACH: {
    name: 'firewall_attach',
    description: {
      progress: 'Attaching firewall.',
      completed: 'Firewall was attached.',
    },
  },
  FIREWALL_DETACH: {
    name: 'firewall_detach',
    description: {
      progress: 'Detaching firewall.',
      completed: 'Firewall was detached.',
    },
  },
};

export const TasksKubernetes = {
  CREATE_POOL: {
    name: 'create',
    description: {
      progress: 'Kubernetes cluster is creating.',
      completed: 'Kubernetes cluster created.',
    },
  },
  UPDATE_POOL: {
    name: 'pool',
    description: {
      progress: 'Kubernetes cluster is updating node pool.',
      completed: 'Kubernetes cluster updated node pool.',
    },
  },
  DELETE_POOL: {
    name: 'delete',
    description: {
      progress: 'Kubernetes cluster is deleting.',
      completed: 'Kubernetes cluster deleted.',
    },
  },
};
